const mapv2info = {
  state: {
    // 地图配置信息
    data: {
      form: {},
      // 地图视图信息 minZoom 0  maxZoom 28
      view: {
        adcode: '100000',
        zoom: 11,
        minZoom: 10,
        maxZoom: 12,
        center: [120.959322, 31.32247],
        extent: [120.807664, 31.103889, 121.161293, 31.54093]
      },
      style: {},
      geojson: {},
      senior: {},
      coordinate: '',
      drawlayer: {},
      screen: {},
      routeSources: [],
      routeCurve: {},
      domstyle: {}
    }
  },

  mutations: {
    SET_MAPINFO: (state, payload) => {
      state.data = payload
    },
    SET_MAPINFOITEM: (state, payload) => {
      Object.keys(payload).forEach(item => { state.data[item] = payload[item] })
    },
    SET_MAPFORM: (state, payload) => {
      state.data.form = payload
    },
    SET_MAPFORMITEM: (state, payload) => {
      Object.keys(payload).forEach(item => { state.data.form[item] = payload[item] })
    },
    SET_MAPSTYLE: (state, payload) => {
      state.data.style = payload
    },
    SET_MAPSTYLEITEM: (state, payload) => {
      Object.keys(payload).forEach(item => { state.data.style[item] = payload[item] })
      // console.log(state.data.style)
    },
    SET_MAPVIEW: (state, payload) => {
      state.data.view = payload
    },
    SET_MAPVIEWITEM: (state, payload) => {
      Object.keys(payload).forEach(item => { state.data.view[item] = payload[item] })
      // console.log(state.data.view)
    },
    SET_MAPGEOJSON: (state, payload) => {
      state.data.geojson = payload
      console.log(state.data.geojson)
    },
    SET_MAPSENIOR: (state, payload) => {
      state.data.senior = payload
      // console.log(state.data.senior)
    },
    SET_MAPSENIORTIEM: (state, payload) => {
      Object.keys(payload).forEach(item => { state.data.senior[item] = payload[item] })
    },
    SET_COORDINATE: (state, payload) => {
      state.data.coordinate = payload
      // console.log(state.data.coordinate)
    },
    SET_MAPDRAWLAYER: (state, payload) => {
      state.data.drawlayer = payload
      console.log(state.data.drawlayer)
    },
    SET_MAPDRAWLAYERITEM: (state, payload) => {
      Object.keys(payload).forEach(item => { state.data.drawlayer[item] = payload[item] })
    },
    SET_MAPSCREEN: (state, payload) => {
      state.data.screen = payload
      console.log(state.data.screen)
    },
    SET_MAPSCREENITEM: (state, payload) => {
      Object.keys(payload).forEach(item => { state.data.screen[item] = payload[item] })
      console.log(payload)
    },
    SET_MAPROUTESOURCE: (state, payload) => {
      state.data.routeSources = payload
    },
    SET_MAPROUTESOURCECLEAR: (state, payload) => {
      state.data.routeSources = []
    },
    SET_MAPROUTECURVE: (state, payload) => {
      state.data.routeCurve = payload
    },
    SET_MAPDOMSTYLE: (state, payload) => {
      state.data.domstyle = payload
    },
    SET_MAPDOMSTYLEITEM: (state, payload) => {
      Object.keys(payload).forEach(item => { state.data.domstyle[item] = payload[item] })
    },
  },

  actions: {
    // 地图配置信息
    savemapinfo({ commit }, payload) {
      commit('SET_MAPINFO', payload)
    },
    savemapform({ commit }, payload) {
      commit('SET_MAPFORM', payload)
    },
    savemapformitem({ commit }, payload) {
      commit('SET_MAPFORMITEM', payload)
    },
    savemapstyle({ commit }, payload) {
      commit('SET_MAPSTYLE', payload)
    },
    savemapstyleitem({ commit }, payload) {
      commit('SET_MAPSTYLEITEM', payload)
    },
    savemapview({ commit }, payload) {
      commit('SET_MAPVIEW', payload)
    },
    savemapviewitem({ commit }, payload) {
      commit('SET_MAPVIEWITEM', payload)
    },
    savemapgeojson({ commit }, payload) {
      commit('SET_MAPGEOJSON', payload)
    },
    savemapsenior({ commit }, payload) {
      commit('SET_MAPSENIOR', payload)
    },
    savecoordinate({ commit }, payload) {
      commit('SET_COORDINATE', payload)
    },
    savemapdrawlayer({ commit }, payload) {
      commit('SET_MAPDRAWLAYER', payload)
    },
    savemapdrawlayeritem({ commit }, payload) {
      commit('SET_MAPDRAWLAYERITEM', payload)
    },
    savemapscreen({ commit }, payload) {
      commit('SET_MAPSCREEN', payload)
    },
    savemapscreenitem({ commit }, payload) {
      commit('SET_MAPSCREENITEM', payload)
    },
    savemaprouteSource({ commit }, payload) {
      commit('SET_MAPROUTESOURCE', payload)
    },
    savemaprouteSourceclear({ commit }, payload) {
      commit('SET_MAPROUTESOURCECLEAR', payload)
    },
    savemaprouteSource({ commit }, payload) {
      commit('SET_MAPROUTECURVE', payload)
    },
  }
}
export default mapv2info
